import { create } from 'zustand';

interface AccessDeniedData {
    name?: string;
    accessToken?: string;
}

interface AccessDeniedState extends AccessDeniedData {
    isDenied: boolean;
    setAccessDenied: (data: AccessDeniedData) => void;
    clearAccessDenied: () => void;
}

export const useAccessDeniedStore = create<AccessDeniedState>(set => ({
    isDenied: false,
    setAccessDenied: data =>
        set({
            isDenied: true,
            ...data,
        }),
    clearAccessDenied: () => set({ isDenied: false }),
}));
